import { gql } from "@apollo/client";

export const activeDeliveryAgents = gql`
  query {
    activeDeliveryAgents {
      id
      name
      currentLat
      currentLng
    }
  }
`;
